var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleEmail = function SvgCircleEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "currentcolor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 17.4H7.4a2 2 0 0 1-2-2V9.2a2 2 0 0 1 2-2h9.8a2 2 0 0 1 2 2v6.2a2 2 0 0 1-2 2Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 10.033V9.2a2 2 0 0 1 2-2h9.8a2 2 0 0 1 2 2v.833m-13.8 0V15.4a2 2 0 0 0 2 2h9.8a2 2 0 0 0 2-2v-5.367m-13.8 0 6.016 2.965a2 2 0 0 0 1.768 0l6.016-2.965",
    stroke: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleEmail);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgcng9IjEyIiBmaWxsPSJjdXJyZW50Y29sb3IiPjwvcmVjdD4KICAgIDxwYXRoCiAgICAgIGQ9Ik0xNy4yIDE3LjRINy40YTIgMiAwIDAgMS0yLTJWOS4yYTIgMiAwIDAgMSAyLTJoOS44YTIgMiAwIDAgMSAyIDJ2Ni4yYTIgMiAwIDAgMS0yIDJaIgogICAgICBmaWxsPSIjZmZmIgogICAgPjwvcGF0aD4KICAgIDxwYXRoCiAgICAgIGQ9Ik01LjQgMTAuMDMzVjkuMmEyIDIgMCAwIDEgMi0yaDkuOGEyIDIgMCAwIDEgMiAydi44MzNtLTEzLjggMFYxNS40YTIgMiAwIDAgMCAyIDJoOS44YTIgMiAwIDAgMCAyLTJ2LTUuMzY3bS0xMy44IDAgNi4wMTYgMi45NjVhMiAyIDAgMCAwIDEuNzY4IDBsNi4wMTYtMi45NjUiCiAgICAgIHN0cm9rZT0iY3VycmVudENvbG9yIgogICAgPjwvcGF0aD4KPC9zdmc+Cg==";